import React, { useState } from "react";
import {
  Box,
  Dialog,
  Grid,
  List,
  ListItem,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material/";
import trans from "../../util/lang/acceptanceLevels";
import common from "../../util/lang/common";
import t__ from "../../util/lang/util";
import InfoButton from "../InfoButton";
import CloseButton from "../CloseButton";
import { MAPCOLORS } from "../Map/mapstyles";

const MapLegendModal = ({ ...props }) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const levels = trans[theme.lang].levels ?? trans["en"].levels;
  const mapColors = MAPCOLORS.default;

  return (
    <Box>
      <InfoButton
        alt="Acceptance Level information modal"
        onClick={() => setOpen(true)}
      />

      <Dialog
        aria-labelledby="acceptance-modal-title"
        open={open}
        fullScreen={fullScreen}
        onClose={() => setOpen(false)}
        id="acceptance-modal"
        maxWidth="md"
        sx={{
          "& .MuiPaper-rounded": {
            borderRadius: 3,
            marginTop: "150px",
            [theme.breakpoints.down("sm")]: {
              borderRadius: 0,
              marginTop: 0,
            },
          },
          "& .MuiDialog-container": {
            alignItems: "flex-start",
          },
        }}
      >
        <Box paddingX={12} paddingY={7} position="relative">
          <CloseButton
            onClick={() => setOpen(false)}
            alt={t__(theme.lang, common, "closeModal")}
            topRight={true}
          />
          <Typography
            variant="h4"
            component="h2"
            id="acceptance-modal-title"
            mb={4}
          >
            <b>{t__(theme.lang, trans, "modal.headline")}</b>
          </Typography>
          <List>
            {Object.keys(levels).map((o, ind) => {
              const len = Object.keys(levels).length;
              return (
                <ListItem
                  key={levels[o].title}
                  disableGutters
                  divider={len - 1 !== ind}
                  sx={{
                    pt: 4,
                    pb: 4,
                  }}
                >
                  <Grid container>
                    <Grid item xs={12} md={4}>
                      <Box
                        display="flex"
                        alignItems="center"
                        mb={{ xs: 3, md: 0 }}
                      >
                        <Box
                          border={1}
                          width={30}
                          height={12}
                          borderRadius="6px"
                          mr={4}
                          bgcolor={mapColors[o]}
                        />

                        <Typography variant="body2">
                          <b>{levels[o].title}</b>
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <Typography variant="body2" color="textPrimary">
                        {levels[o].desc}
                      </Typography>
                    </Grid>
                  </Grid>
                </ListItem>
              );
            })}
          </List>
        </Box>
      </Dialog>
    </Box>
  );
};

export default MapLegendModal;
